export enum PastellStatus {
  AEnvoyer = 'AEnvoyer',
  EnvoiEnCours = 'EnvoiEnCours',
  Envoye = 'Envoye',
  Signe = 'Signe',
  Vise = 'Vise',
  RejetSignataire = 'RejetSignataire',
  RejetVisa = 'RejetVisa',
  ErrorIn = 'ErrorIn',
  ErrorOut = 'ErrorOut',
  Annule = 'Annule',
}
